<template>
<div>
	<!--header-->
	<TopAppBar
		leftBtnMode="arrow_back"
		:rightBtnMode="rightBtnMode"
		:title= "brandName"
		:rightBtnMethod="rightBtnMethod"
    :hideCategory="false"
		:staticMode="true"
	>
	</TopAppBar>
		<!--header ends-->
	<div class="d-flex h-full flex-column">
		<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
					{{this.$t('1343')}}
				</div>
			</div>
			<div class="divider"></div>
			<!-- subtabs -->

			<div class="container container--narrow mgt-50 pdb-50">
				 <img :src="image" v-if="image" alt="Uploaded License">
				<div class="mgt-24 t-headline7 l-spacing6 font-m">{{ licenseName }}</div>

				<div class="mgt-28 t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1344') }}</div>
				<div class="mgt-4 t-body1 font-r l-spacing48">{{ issueDate? $moment(issueDate).format("L"):'' }}</div>
				<div v-if="useValidity" class="mgt-24 t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1345') }}</div>
				<!-- <div v-if="useValidity" class="mgt-4 t-body1 font-r l-spacing48 t-color-textfieldActive">{{$t('3113').replace('{str}',expiryDate) }}</div> -->
				<div v-if="useValidity" class="mgt-4 t-body1 font-r l-spacing48 t-color-textfieldActive">{{expiryDate?$moment(expiryDate).format("L"):'' }}</div>

				<div class="mgt-50">
					<router-link tabindex="0" to="/licenseModify" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1346')}}</span>
					</router-link>
					<button class="mdc-button bg-white t-color-secondaryBtnText b-radius4" @click="confirmDelete()" @keypress="confirmDelete()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{ $t('1347') }}</span>
					</button>
				</div>
			</div>
		</main>
  </div>
  </div>
</template>

<script>

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue';
import {topAppBarMixin} from '@/mixins/topAppBar.js';
import {joinMixin} from '@/mixins/join.js';
import {MDCRipple} from '@material/ripple';
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import httpService from "@/api/httpService.js";
import licenseApi from "@/api/licenseApi.js";
import memberApi from "@/api/memberApi.js";

export default {
	components: {
		TopAppBar,
		TopAppBarDrawer,
	},

	mixins: [topAppBarMixin, joinMixin],

	data() {
		return {
			language: localStorage.getItem("languageInfo") ? JSON.parse(localStorage.getItem("languageInfo")).code : null,
			memberId: null,
			storeId: null,
			licenseId: null,
			licenseName: null,
			image: null,
			issueDate: null,
			expiryDate: null,
			useValidity: true,
			brandName : localStorage.getItem('brandName')
		};
	},

	mounted() {
		memberApi.getMemberInfo().then((response) => {
			this.memberId = response.data.data.id;
			this.storeId = response.data.data.storeCode;

			let params = {
			memberId: this.memberId
			};
			this.getLicenseResponsibility(params);
		}).catch((err) => {
			console.log(err);
		});
		const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
			let button = new MDCRipple.attachTo(el);
			return button;
		});
	},

	methods: {
		getLicenseResponsibility(params) {
			licenseApi.getLicenseResponsibility(params).then((response)=>{
				this.useValidity = response.data.data.useValidPeriod;
				let params = {
					memberId: this.memberId
				};
				this.getLicenseInfo(params);
			}).catch((err)=>{
				console.log(err);
			});
		},
		getLicenseInfo(params) {
			const options = { year: 'numeric', month: 'long', day: 'numeric' };

			licenseApi.getMemberLicenseDetails(params).then((response)=>{

				this.licenseId = response.data.data.licenseMember.id;

				if(response.data.data != null) {
					if(this.useValidity){
						if(response.data.data.licenseMember.expiryDate < new Date().getTime()){
                            this.$alert({
                                title: this.$t("1360"),
                                content:this.$t("1361") + " " + this.$t("1362") ,
                                accept: this.$t("1364"),
                                //cancel: this.$t("1363"),
                            }).then(() => {
                                //this.deleteOldLicense(this.licenseId);
                            }).catch(() => {
                                this.$router.push('/home');
                            });
                        }
					}
				}

				let local =  "ko-KR";
				if(this.language == "en"){
					local = "en-US";
				}

				this.issueDate = response.data.data.licenseMember.issueDate;
				this.expiryDate = response.data.data.licenseMember.expiryDate;
				// this.issueDate = new Date(response.data.data.licenseMember.issueDate);
				// this.expiryDate = new Date(response.data.data.licenseMember.expiryDate);
				// this.issueDate = this.issueDate.toLocaleDateString(local, options);
				// this.expiryDate = this.expiryDate.toLocaleDateString(local, options);

				if(response.data.data.licenseMember.file.resourceUri){
					this.image = response.data.data.licenseMember.file.resourceUri;
				} else {
					this.image = "images/thumbnail.png";
				}

				this.licenseName = response.data.data.licenseResponsibility.name;
			}).catch((err) => {
				console.log(err);
			});
		},
		confirmDelete() {
			this.$confirm({
				title: this.$t("1356"),
				content:this.$t("1357"),
				accept: this.$t("1359"),
				cancel: this.$t("1358"),
			}).then(() => {
				let params = {
					'id':this.licenseId
				};
				this.processDelete(params);
			}).catch(() => {});
		},
		processDelete(params) {
			licenseApi.deleteLicense(params.id).then((response)=>{
				this.$router.push({
					name:'MyInformation'
				});
			}).catch((error)=>{
				console.log(error);
			});
		},
		deleteOldLicense(id) {
			licenseApi.deleteLicense(id).then((response)=>{
				this.$router.push('/licensePopulate');
			}).catch((error)=>{
				console.log(error);
			});
		},
		goBack() {
			this.$router.push({
				name:'MyInformation'
			});
		}
	},
};
</script>
